const { decodeReplay } = require('./replayDecoder');
const config = require('../config');

function base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

function fetchReplay(id) {
  return fetch(`${config.BACKEND_URL}/api/getReplay`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id,
    }),
  }).then(response => response.json())
  .then(responseObj => decodeReplay(base64ToArrayBuffer(responseObj.replay)));
}

module.exports = {
  fetchReplay,
};
